import { LinkItem } from '@occc/ui-design-system';
import { routeCreator } from '../routeCreator';

export const getPageLinks = (pageLabel: string): LinkItem[] => [
  {
    to: routeCreator.list(),
    label: 'Surveys',
    key: 'surveys-list-page',
  },
  {
    label: pageLabel,
    key: 'surveys-create-page',
  },
];
